export const ACTIONS_ALLOWED = ['toggle', 'hide', 'show', 'toggleClass'];

export const DEFAULT_CLASSES = {
    target: {
        visible: ['gh-ct-visible'],
        hidden: ['gh-ct-hidden'],
    },
    trigger: {
        active: ['gh-trigger-active'],
        inactive: ['gh-trigger-inactive'],
        contrast: ['gh-trigger-contrast'],
    },
};
